<template>
  <div>
    <CDataTable
        :items="tableItems"
        :fields="fields"
        table-filter
        :items-per-page="100"
        :items-per-page-select='{"label": $t("NumberOfItemsPerPage"), "values": [100,250,1000]}'
        hover
        sorter
        :sorterValue="{column: 'total_traffic', asc: false}"
        pagination
        ref="tableTraffic"
        :tableFilterValue.sync="search"
    >
      <template #total_traffic="{item}">
        <td>{{ formatTraffic(item) }}</td>
      </template>
      <template #total_requests="{item}">
        <td>{{ formatRequests(item) }}</td>
      </template>

      <template v-slot:footer>
        <tfoot>
          <tr>
            <th>{{ $t('Total') }}</th>
            <th></th>
            <th id="totalTrafficId">{{ totalTraffic }}</th>
            <th id="totalRequestId">{{ totalRequest }}</th>
          </tr>
        </tfoot>
      </template>
    </CDataTable>
    <div class="float-right">
    <a-button @click="exportTraffic"
              icon="download" class="mr-2 mt-1">{{ $t('Download Breakdown') }}
    </a-button></div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import numeral from "numeral";

function computeTableColumnTotal(colNumber)
{		
  let result = 0;
  try {
    let tableElem = window.document.getElementsByClassName("table")[0]; 		   
    if (tableElem !== undefined) {
      let tableBody = tableElem.getElementsByTagName("tbody").item(0);
      let i;
      let howManyRows = tableBody.rows.length;

      for (i=0; i<(howManyRows); i++)
      {
          let thisTrElem = tableBody.rows[i];
          let thisTdElem = thisTrElem.cells[colNumber];			
          let thisTextNode = thisTdElem.childNodes.item(0);

          if (colNumber === 2) {
            const [value, unit] = thisTextNode.data.replaceAll(",", "").split(" ");
            result += convertToBytes(parseFloat(value), unit);
          } else {
            let thisNumber = parseFloat(thisTextNode.data.replaceAll(",", ""));
            if (!isNaN(thisNumber)) result += thisNumber;
          }
      }

      if (colNumber == 2)
      result = numeral(result).format('0.00 b');
    }  		
  }
  catch (ex)
  {
     result = 0;
  }
  return result;
}

const convertToBytes = (value, unit) => {
    switch (unit) {
        case 'TB':
            return value * 1000 * 1000 * 1000 * 1000;
        case 'GB':
            return value * 1000 * 1000 * 1000;
        case 'MB':
            return value * 1000 * 1000;
        case 'KB':
            return value * 1000;
        default:
            return value;
    }
}

export default {
  props: ['domains', 'trafficData'],
  data() {
    return {
      fields: [
        {
          key: 'domain',
          label: this.$t('Domain')
        },
        {
          key: 'shadow',
          label: this.$t('Shadow')
        },
        {
          key: 'total_traffic',
          label: this.$t('domain.TotalTraffic')
        },
        {
          key: 'total_requests',
          label: this.$t('domain.TotalRequests')
        }
      ],
      search: null
    }
  },
  watch: {
    search() {
      setTimeout(function(){
        let totalR = computeTableColumnTotal(3);
        let totalRequestElem = window.document.getElementById("totalRequestId");
        if (totalRequestElem) {
          totalRequestElem.innerHTML = totalR;
        }
        let totalT = computeTableColumnTotal(2);
        let totalTrafficElem = window.document.getElementById("totalTrafficId");
        if (totalTrafficElem) {
          totalTrafficElem.innerHTML = totalT;
        }        
      }, 1000);
    }
  },
  computed: {
    totalTraffic() {
      const total = this.tableItems.map(x => x.total_traffic).reduce((a, b) => a + b, 0);
      return numeral(total).format('0.00 b');
    },
    totalRequest() {
      const total = this.tableItems.map(x => x.total_requests).reduce((a, b) => a + b, 0);
      return total;
    },
    tableItems: function () {
      const domainTraffic = [];
      for (let name of Object.keys(this.trafficData)) {
        if (name !== 'null') {
          let domain = {
            domain: name,
            shadow: null,
            total_traffic: 0,
            total_requests: 0
          };

          if (!this.trafficData[name]) {
            domainTraffic.push(domain);
            continue;
          }
          
          const traffic = [...this.trafficData[name]].sort(this.dynamicSort('shadow'));
          for (let t of traffic) {
            domainTraffic.push({
              domain: t.domain || name,
              shadow: t.shadow,
              total_traffic: t.total_traffic,
              total_requests: t.total_request
            });
          }
        }
      }

      return domainTraffic;
    }
  },
  methods: {
    dynamicSort(property) {
        let sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    },
    formatTraffic(item) {
      return numeral(item.total_traffic).format('0.00 b');
    },
    formatRequests(item) {
      return numeral(item.total_requests).format('0,0');
    },
    exportTraffic() {
      const headerOrder = [];
      const headers = [];
      for (let field of this.fields) {
        headers.push(field.label);
        headerOrder.push(field.key);
      }

      const ws = XLSX.utils.aoa_to_sheet([headers]);

      let data = this.tableItems;
      data.sort((a,b) => (a.total_traffic < b.total_traffic) ? 1 : ((b.total_traffic < a.total_traffic) ? -1 : 0));
      data = data.map(item => {
        const obj = Object.assign({}, item);
        obj.total_traffic = this.formatTraffic(obj);
        return obj;
      });
      data.push({
        domain: this.$t('Total'),
        total_traffic: this.totalTraffic,
        total_requests: this.totalRequest
      });
      

      XLSX.utils.sheet_add_json(ws,data, {header: headerOrder, skipHeader: true, origin: 'A2'});
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Traffic');

      XLSX.writeFile(wb, 'export-traffic.xlsx');
    }
  }
}
</script>